module.exports = __webpack_public_path__ + "img/add-debit-card.84bf6ab2.jpg";